import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { get, map } from "lodash";

import { fetchGet, fetchPost } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
//import Checkbox from "@material-ui/core/Checkbox";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";
import FormSection from "../../Common/FormSection";
//import ProfileSearchInput from "../../Common/ProfileSearchInput";
import ProfileMatchExpress from "../../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpress";

// import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";
//import { custom } from "../../../resources/En";
// import { isAllowed } from "../../../utils/users";
import images from "../../../assets/img/images";

const styles = {
  dialog: {
    minWidth: "370px",
  },
  title: {
    textTransform: "uppercase",
    color: colors.black87,
    fontWeight: 500,
  },
  radioGroup: {
    flexDirection: "row",
  },
  formControlRoot: {
    marginRight: "24px",
  },
  plusIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
};

const AddAssociations = (props) => {
  const { classes, language, profile, setOpen, handleComplete} = props;


  const [formValues, setFormValues] = React.useState({});
  const [lov, setLov] = React.useState();
  React.useEffect(() => {
    if (true && !lov) {
      fetchLov();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [true]);

  const fetchLov = async () => {
    try {
      setLov({
        association_types: await fetchGet("association_types?active=true"),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const reset = () => {
    setFormValues({});
  };

  const onClose = () => {
    handleComplete(profile)
    reset();
    setOpen(false);
  };

  const handleChange = (id, index, value, profile=false) => {
    if (profile){
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
        })
      );
    } else{

      setFormValues(
        update(formValues, {
          [id]: { $set: value },
        })
      );
    }
  };

  const submit = async () => {
    try {
      await fetchPost("profile_associations", {
        p1_profile_id: localStorage.getItem("prof1"),
        p2_profile_id: get(profile, ["id"]),
        p1_association_type_id: get(formValues, ["p1_association_type_id"]),
        description: "",
        active: true,
      });
      reset();
      handleComplete(profile)
      setOpen(false);

    } catch (e) {
      console.log(e);
    }
  };

  // const isValidForm = () => {
  //   let isValid = true;
  //   if (!get(formValues, ["profile"])) isValid = false;
  //   if (!get(formValues, ["p1_association_type_id"])) isValid = false;
  //   return isValid;
  // };

  return (
    <>
      <Dialog
        open={true}
        classes={{
          paperScrollPaper: classes.dialog,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ paddingTop: "24px" }}
        >


          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs container direction="column" alignItems="center">
                <Grid container direction="column" alignItems="center">
                  <Grid item style={{ margin: "24px 0px 10px 0px" }}>
                    <img src={images.successIcon} alt="success" />
                  </Grid>
                  <Grid item className="text-54 text-center bold-500" style={{ margin: "0px 0px 10px 0px" }}>
                    {I18n.get("profiles_profileCreated")}
                  </Grid>
                </Grid>
                <Grid item className="dialogTitle">
                  {I18n.get("profiles_addAssociationTo")}
                </Grid>
                <Grid item className="text-54">
                  {get(profile, ["name"])}
                </Grid>
              </Grid>
              <Grid item xs={2} className={classes.closeBtn} style={{position:"relative", top: "-60px"}}>
                <CloseIcon closeFunction={() => {onClose();}} />
              </Grid>
            </Grid>
          </Grid>



          <Grid item style={{ padding: "24px" }}>
            <Grid container direction="column">
                <ProfileMatchExpress
                profile={profile}
                style={{
                  border: "none",
                  backgroundColor:
                    get(props, ["profileMatchProps", "backgroundColor"]) ||
                    colors.lightGrey,
                  padding: 0,
                  maxWidth: get(props, ["sizes", "profile"]),
                }}
              /> <br/>
              <Grid container direction="row" justifyContent="center" alignItems="center">
                <span style={{fontWeight:"bold", position: "relative", top: "-12px"}}>Is &nbsp;</span>
                <FormSection
                  style={{width:"94.14%"}}
                  formValue={[
                    get(formValues, ["p1_association_type_id"]) || "",
                  ]}
                  setFormValue={handleChange}
                  id="p1_association_type_id"
                  type="select"
                  noLabel
                  options={{
                    comboBox: true,
                    options: map(
                      get(lov, ["association_types"]),
                      (item) => ({
                        id: item.id,
                        name: get(item, [`name_${language}`]),
                      })
                    ),
                  }}
                />
              </Grid>
              
              <Grid item>
                <Grid container justify="center">
                  <Grid item>
                    <CustomButton color="primary" onClick={() => {onClose(); }}>
                      {I18n.get("site_cancel")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ marginLeft: "10px" }}>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      // disabled={!isValidForm()}
                      onClick={submit}
                    >
                      {I18n.get("site_confirm")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(AddAssociations));
